module.exports = __webpack_public_path__ + "media/images/lb/825-437d67c51f2162268958929ab5a9649b.svg";